<div class="container" responsive-breakpoints>
  <div class="flex jc-sb ai-c header-wrapper">
    <div class="mapfre-mr-m logo-wrapper" *ngIf="!_showBackButton">
      <img src="assets/images/mapfre-logo.svg" alt="">
    </div>

    <div class="mapfre-hide-desktop flex ai-c jc-sb w-95" *ngIf="_showBackButton">
      <img (click)="onBack()" class="back-icon" src="assets/icons/arrow-left.png" alt="">
      <div class="flex-grow flex jc-c">
        <div class="mapfre-fs-s dark" *ngIf="_headerTitle">{{_headerTitle}}</div>
        <app-download-pdf-link *ngIf="state.userIdentified"></app-download-pdf-link>
      </div>
    </div>

    <div *ngIf="checkShowPolicySelect()">
      <mat-form-field>
        <mat-select [(value)]="policyHealthSelected" (selectionChange)="changeCodGuia($event)">
          <mat-option *ngFor="let policy of healthPolicies" [value]="policy?.codGuia">
            {{policy?.policyName}} (*{{policy?.cardId}})
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>